import React from 'react';
import PropTypes from 'prop-types';

export class ScrollTopInjector extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      scrolled: 0
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    const scrolled =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    if (scrolled !== this.state.scrolled) {
      this.setState({ scrolled });
    }
  }

  componentDidMount() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { children } = this.props;
    const { scrolled } = this.state;

    return React.Children.map(children, child =>
      React.cloneElement(child, { scrolled })
    );
  }
}

ScrollTopInjector.propTypes = {
  children: PropTypes.any.isRequired
};
